import env from '../config';
import { FirebaseApp, initializeApp } from 'firebase/app';
// import { getAnalytics } from 'firebase/analytics';

const app = initializeApp(env.firebaseConfig);
// const analytics = getAnalytics(app);

export const useFirebaseApp = (): FirebaseApp => {
	return app;
};
